/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {CampaignContextActionsComponent} from './campaign-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {emptyRouteView} from '../common/directives/html/route-view-components';

const listTemplate = '<adn-campaign-list-page [list]="list"></adn-campaign-list-page>';

export function campaignStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('campaigns.campaign', LineItemResource, 'app.adv', 'app', listTemplate);
    
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            listConfig: function() {
              return {moreParams: {excludeIfMissing: 'productId'}, listIdOverride: 'Campaign'};
            }
          },
          views: {
            'context@app': emptyRouteView()
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: {
              lineItemView: /*@ngInject*/ function($stateParams) {
                const dataViewResource = adnRouterHelper.services.dataViewResource();

                if (!$stateParams.isNew) {
                  return dataViewResource.get('LineItemView', {id: $stateParams.id || 'undefined-id'}, false);
                }
              },
              campaignEditRouteKey: function() {
                return 'campaign-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              campaignEditInputs: /*@ngInject*/ function(lineItemView) {
                return {lineItemView};
              },
              model: /*@ngInject*/ function($stateParams) {
                return adnRouterHelper.services.resource(LineItemResource).get({id: $stateParams.id}).$promise;
              }
            },
            views: {
              'content@app': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'campaignEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'campaignEditInputs'
                }
              },
              'context@app': {
                component: CampaignContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              }
            }
          }, 'LineItem', [{type: 'Advertiser', func: 'canBeShownAdvertiser'}, {type: 'Order', func: 'isNotSelfService'}]));
  }, adnRouterHelper);
}
